import { Grid } from "@material-ui/core";
import QueueStats from "./QueueStats";
import { FilterCalls } from "../../helpers/callFilter";

function QueueStatsUser(props) {

    const userName = props.user.split("@")[0]
    let totalReady = 0;
    let totalNotReady = 0;

    return(
        <>
            <Grid item style={{display: "flex", alignItems: "center", flexGrow: 4, paddingLeft: "15px", maxWidth: "200px", width: "100%"}}>
                <Grid>
                    {userName}
                </Grid>
            </Grid>
        {
            props.queues.map(q => {
                let isExpanded = props.selectedQueue === q;
                //get a count of things from each call queue
                let queue = props.calls.find(cq => cq.Name.toLowerCase() === q.replaceAll(' ', '').toLowerCase() );
                //If the filter is set to all
                let counts = {
                    Ready: 'Loading',
                    NotReady: 'Loading'
                };
                let pdUserID = props.pipedriveUsers[props.user];
                if (!pdUserID) {
                    counts.Ready = "User Not Found In Pipedrive";
                    counts.NotReady = "User Not Found In Pipedrive";
                }
                if (queue) {
                    let calls = [];
                    if (props.useConfig) {
                        calls = FilterCalls(props.config, queue.contacts)
                    } else {
                        calls = queue.contacts;
                    }
                    let ur = calls.filter(call => {
                        return Date.parse(call.CallTime) < Date.now() && call.PipedriveUserID === pdUserID;
                    })
                    let unr = calls.filter(call => {
                        return Date.parse(call.CallTime) > Date.now() && call.PipedriveUserID === pdUserID;
                    })
                    counts.Ready = ur.length;
                    counts.NotReady = unr.length;
                    totalReady += counts.Ready;
                    totalNotReady += counts.NotReady;
                }

                return <QueueStats counts={counts} isExpanded={isExpanded}  label={q} key={q} />
            })
        }
        <QueueStats counts={{Ready: totalReady, NotReady: totalNotReady}} label={"Totals"} key={`${props.worker}-total`} />
        </>
    )
}

export default QueueStatsUser;